var MessageErrorScopeType = {
  ODG: "ODG",
  BOARD: "BOARD",
};


export default MessageErrorScopeType;

